import { render, staticRenderFns } from "./NewNewPagePropertyEditor.vue?vue&type=template&id=6dcae390&scoped=true&"
import script from "./NewNewPagePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewNewPagePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcae390",
  null
  
)

export default component.exports